import { Flex, IconButton, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react';
import React from 'react';
import { Sparkles, VerticalEllipsisIcon } from '../../icons';
import { Store } from '../../store';
import { useSendMessage } from '@outdoorly/react-chat-sdk';

export const AIPersonaIndicator = (props: { expertFirstName: string }) => {
  const { expertFirstName } = props;

  const sendMessage = useSendMessage();
  const transferToHuman = () => sendMessage('I want to talk to a human.');

  const labels = Store.useState(
    (s) =>
      s.labels.substitute({
        expertName: expertFirstName
      }),
    [expertFirstName]
  );

  return (
    <Flex
      position="sticky"
      top="0px"
      left="0"
      w="full"
      p="8px"
      justify="space-between"
      borderRadius="24px"
      backgroundColor="scheme.purple0"
      boxShadow="0px 2px 24px 0px rgba(0, 0, 0, 0.16)"
      align="center"
      zIndex="overlay"
    >
      <Flex gap="4px" align="center">
        <Sparkles color="scheme.purple3" height="17px" width="17px" />
        <Text variant="label-small" color="scheme.purple8">
          {labels.chattingWithPersona}
        </Text>
        <Text
          p="2px 4px"
          borderRadius="24px"
          border="1px solid"
          borderColor="scheme.purple1"
          color="scheme.purple5"
          fontSize="10px"
          fontWeight={600}
          lineHeight="125%"
        >
          BETA
        </Text>
      </Flex>
      <Menu variant="ai-persona-indicator">
        <MenuButton
          as={IconButton}
          variant="solid"
          aria-label="Learn more"
          icon={
            <VerticalEllipsisIcon height="8px" width="8px" fill="scheme.purple8" transform="rotate(90deg)" />
          }
          backgroundColor="scheme.purple1"
          _active={{
            backgroundColor: 'scheme.purple3'
          }}
          _focus={{
            backgroundColor: 'scheme.purple1'
          }}
          _hover={{
            backgroundColor: 'scheme.purple2'
          }}
          height="20px"
          minW="20px"
          maxW="20px"
          borderRadius="12px"
        />
        <MenuList>
          <MenuItem onClick={transferToHuman}>
            <Text as="span" variant="paragraph-medium" color="scheme.contentSecondary">
              Switch to a human
            </Text>
          </MenuItem>
          {/* <MenuItem>
            <Text as="span" variant="paragraph-medium" color="scheme.contentSecondary">
              What is this?
            </Text>
          </MenuItem> */}
        </MenuList>
      </Menu>
    </Flex>
  );
};
